import React, { useState, useRef, Fragment, useEffect } from 'react';
import { Box, Button, Typography, IconButton, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Lightbox from 'react-image-lightbox';
import { console_log } from '../helpers/untils';

const ImageUploadBox = (props) => {
  const { title, hint = "", fieldName, onChangeImage, galleryUrl = "" } = props

  useEffect(() => {

  }, [])

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(galleryUrl);
  const fileInputRef = useRef(null); // Create ref to input

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    console_log(`file.type::::`, file)
    if (file && (true || file.type.startsWith('image/'))) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
      onChangeImage(fieldName, file)
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
    setPreview(null);

    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    onChangeImage(fieldName, null)
  }

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const onClickShowPreviewImage = () => {
    setCurrentImage(preview)
    setImageModalOpen(true)
  }

  return (
    <Fragment>
      <Box
        sx={{
          border: '2px dashed #ccc',
          borderRadius: '8px',
          padding: '20px',
          textAlign: 'center',
          // cursor: 'pointer',
          width: '100%',
          // maxWidth: 400,
          margin: '0 auto',
        }}
      >
        <Stack direction={`column`} spacing={2}>
          <Typography variant="subtitle1">{title}</Typography>
          {hint && (
            <Typography variant="caption" color="textSecondary">{hint}</Typography>
          )}
          {preview && (
            <Box mt={2} position="relative">
              {/* <Typography variant="subtitle1">Preview:</Typography> */}
              <img
                src={preview}
                alt="Preview"
                style={{
                  cursor: 'pointer',
                  maxWidth: '100%',
                  height: 200,
                  objectFit: 'contain',
                  objectPosition: 'top center'
                }}
                onClick={() => onClickShowPreviewImage()}
              />
              <IconButton
                onClick={() => handleDeleteImage()}
                title="Delete"
                sx={{
                  position: 'absolute',
                  top: '0px',
                  right: '0px',
                  backgroundColor: 'rgba(255,255,255,0.75)',
                  ':hover': { backgroundColor: '#f8d7da' },
                  border: '1px solid #ccc',
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Box>
          )}

          <div>
            <input
              accept="image/*" // accept="*/*"
              type="file"
              id={`upload-input-${fieldName}`}
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={(e) => handleImageChange(e)}
            />
            <label htmlFor={`upload-input-${fieldName}`}>
              <Button variant="outlined" component="span">
                Upload Image
              </Button>
            </label>
          </div>
        </Stack>
      </Box>

      {imageModalOpen && (
        <Lightbox
          mainSrc={currentImage}
          onCloseRequest={() => setImageModalOpen(false)}
        />
      )}
    </Fragment>

  );
};

export default ImageUploadBox;
